import React from 'react';
import i18n from 'i18n';
import { pick, filter, isEmpty } from 'lodash';
import { useHistory } from 'react-router-dom';
import useLoadPackages from 'hooks/data/useLoadPackages';
import useGlobalLoader from 'hooks/useGlobalLoader';
import withKeepingLastFocus from 'components/HOCs/withKeepingLastFocus';
import AllPackagesPage from './AllPage';

// pick only neccessary params
const getParams = (search = '') => {
  const params = Object.fromEntries(new URLSearchParams(search).entries());
  return pick(params, ['channelId', 'vodAssetId']);
};

const packgesSelector = ({ main, additional }) => {
  const result = [
    {
      listId: 0,
      title: i18n.t('packages.mainServicesTitle'),
      items: main,
    },
    {
      listId: 1,
      title: i18n.t('packages.extraServicesTitle'),
      items: additional,
    },
  ];

  return filter(result, ({ items }) => !isEmpty(items));
};

const AllPackagesPageContainer = ({ lastFocusKeeper }) => {
  const { location } = useHistory();
  const params = getParams(location.search);
  const isFiltering = !isEmpty(params);
  const { isLoading, isFetching, data } = useLoadPackages(!isEmpty(params) ? params : null, {
    select: packgesSelector,
  });

  useGlobalLoader(isLoading || isFetching, { hideOnBack: true });

  if (isLoading) return null;

  return (
    <AllPackagesPage
      key={isFiltering ? 1 : 0}
      packageData={data}
      lastFocusKeeper={lastFocusKeeper}
      isFiltering={isFiltering}
      searchParams={params}
    />
  );
};

export default withKeepingLastFocus(AllPackagesPageContainer);
